import React from "react";
import { LegalLayout, H2, P, UL, LI } from "@/components/LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout
      title="Terms of Service"
      updated="June 1, 2026"
      intro="These terms govern your use of Next Time. By using the Service, you agree to them."
    >
      <H2>1. Acceptance of terms</H2>
      <P>By accessing or using Next Time (the “Service”), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.</P>

      <H2>2. What Next Time is (and is not)</H2>
      <P>Next Time is a self-improvement and communication-practice tool. It uses AI to help you reflect on difficult moments and rehearse conversations. It is <strong>not</strong> therapy, counseling, medical advice, legal advice, or a crisis service, and it is not a substitute for care from a qualified professional. If you are experiencing a mental-health emergency, contact your local emergency number or a crisis line immediately.</P>

      <H2>3. Eligibility</H2>
      <P>You must be at least 13 years old (or the minimum age of digital consent in your jurisdiction) to use the Service.</P>

      <H2>4. Your account and content</H2>
      <UL>
        <LI>You are responsible for activity that happens under your account or device session.</LI>
        <LI>You retain ownership of the content you create. You grant us a limited license to process it solely to provide the Service (including AI analysis and feedback).</LI>
        <LI>You agree not to submit content that is unlawful, harmful, or that infringes the rights of others.</LI>
      </UL>

      <H2>5. Acceptable use</H2>
      <P>You agree not to misuse the Service, including by attempting to disrupt it, reverse-engineer it, access it through unauthorized means, or use it to harass or harm others.</P>

      <H2>6. AI-generated content</H2>
      <P>Responses, scenarios, and feedback are generated by AI and may be inaccurate or incomplete. Use your own judgment. You are solely responsible for decisions you make based on the Service.</P>

      <H2>7. Subscriptions</H2>
      <P>Some features require a paid subscription (“Next Time Pro”). Subscriptions are governed by our <a href="/subscription-terms" className="underline hover:text-ink">Subscription Terms</a>, which are incorporated into these Terms.</P>

      <H2>8. Disclaimers</H2>
      <P>The Service is provided “as is” and “as available” without warranties of any kind, whether express or implied, including fitness for a particular purpose. We do not warrant that the Service will be uninterrupted or error-free.</P>

      <H2>9. Limitation of liability</H2>
      <P>To the maximum extent permitted by law, Next Time will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss arising from your use of the Service.</P>

      <H2>10. Termination</H2>
      <P>You may stop using the Service at any time. We may suspend or terminate access if you violate these Terms or to protect the Service and its users.</P>

      <H2>11. Changes to the terms</H2>
      <P>We may update these Terms from time to time. Continued use after changes take effect constitutes acceptance of the updated Terms.</P>

      <H2>12. Contact</H2>
      <P>Questions about these Terms? Email <a href="mailto:decompresspause@gmail.com" className="underline hover:text-ink">decompresspause@gmail.com</a>.</P>
    </LegalLayout>
  );
}
